<!-- Parent Flex Container -->
<div class="flex h-screen w-full">
  <!-- Drawer Sidebar -->
  <aside
  id="drawer" style="width: 480px; "
  class="kt-drawer kt-drawer-start w-64
         shadow-lg border-r border-gray-200
         flex-shrink-0 flex flex-col"
  data-kt-drawer="true"
  data-kt-drawer-width="320px"
  data-kt-drawer-direction="start"
  data-kt-drawer-toggle="#drawer"
  data-kt-drawer-overlay="false"
>

    <!-- Drawer Header -->
    <div
      class="kt-drawer-header flex items-center justify-center px-5 py-3 border-b">
      <h3 class="kt-drawer-title text-lg centr font-semibold ">
        Disclosure Forms
      </h3>
    </div>

    <!-- ✅ Drawer Content -->
    <div class="kt-drawer-content kt-scrollable p-5 flex-1 overflow-y-auto" >
      <form class="checkbox-form space-y-3" [formGroup]="disclosureSelectorForm" (ngSubmit)="onSubmit($event)">
        <div class="font-semibold text-sm">
          Choose from the following disclosure forms
        </div>
        <div class="text-sm mb-3">
          If more than one disclosure form is chosen, the disclosure forms will be combined into one PDF.
        </div>

        <!-- ✅ Full Checkbox List -->
        <div class="cb-wrap flex items-center space-x-2" *ngFor="let field of checkboxFields">
          <input type="checkbox" [formControlName]="field.name" kendoCheckBox class="cursor-pointer"
            [id]="field.name" />
          <label class="checkbox-label text-xs  cursor-pointer" [for]="field.name">
            {{ field.label }}
          </label>
        </div>

        <!-- Submit Button -->
        <div class="mainfloatbutton mt-6">
          <button kendoButton primary="true" type="submit" class="w-full px-4 py-2 rounded-md bg-blue-600 text-white font-medium
                   hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-400
                   disabled:opacity-50 disabled:cursor-not-allowed transition">
            Submit
          </button>
        </div>
      </form>
    </div>

    <!-- ✅ Drawer Footer -->
    <div
      class="kt-drawer-footer px-5 py-3 text-sm dark:text-gray-400 border-t">
      Select the required disclosure forms and click Submit
    </div>
  </aside>
  <main class="flex-1 shadow-lg rounded-lg p-4 overflow-y-auto">
    <gd-pdfviewer [filePath]="somePath" *ngIf="selectedFormDatashow" [rawPdfData]="selectedFormData"></gd-pdfviewer>
  </main>
</div>